import React from "react";
import { Redirect, Route, withRouter } from "react-router-dom";

import { useSelector } from "react-redux";

export const PrivateRoute = ({ component, location, ...rest }) => {
  const { token } = useSelector((store) => ({
    token: store.authReducer?.token,
  }));

  {
    return (
      <>
        {token.length !== 0 ? (
          <Route {...rest} component={component} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location.pathname },
            }}
          />
        )}
      </>
    );
  }
};
export default withRouter(PrivateRoute);
